/** Display-only split, in event-currency units (not cents). Budget math is unchanged. */
export function getDisplayedFinancialCostSplit(
  total: number | null | undefined,
  flights: number | null | undefined,
): { land: number | null; flights: number | null } {
  // Legacy budgets combine flights and ground transport. Never present that
  // combined value (or an unavailable breakdown) as airfare or as zero airfare.
  if (total == null || flights == null || !Number.isFinite(total) || !Number.isFinite(flights)) {
    return { land: null, flights: null };
  }
  const displayedFlights = Math.round(flights);
  // This view already displays whole units. Assign the rounding remainder to
  // land so the two displayed parts always add up to the unchanged total.
  return { land: Math.round(total) - displayedFlights, flights: displayedFlights };
}
